export enum VillasContentSections {
    OVERVIEW = 'overview',
    ROOMS_AND_AMENITIES = 'rooms-and-amenities',
    LOCATION = 'location',
    THINGS_TO_KNOW = 'things-to-know',
  }

export const VILLAS_CONTENT_SECTION_LABELS = {
  [VillasContentSections.OVERVIEW]: 'Overview',
  [VillasContentSections.ROOMS_AND_AMENITIES]: 'Rooms & amenities',
  [VillasContentSections.LOCATION]: 'Location',
  [VillasContentSections.THINGS_TO_KNOW]: 'Things to know',
} as const

export const VILLAS_STICKY_HEADER_ENABLED_SECTIONS = new Set<VillasContentSections>([
  VillasContentSections.OVERVIEW,
  VillasContentSections.ROOMS_AND_AMENITIES,
  VillasContentSections.LOCATION,
  VillasContentSections.THINGS_TO_KNOW,
])
